import * as React from 'react';

import { HowToHelpType } from '@shared/enums';
import { useGetIconOptimized } from '@shared/hooks/useGetIconOptimized';

import { ModalBasic } from '@shared/ui/modal/ModalBasic';
import { Application } from '@widgets/cabinet/applicationCard/types';
import { ApplicationModalPurchaseType } from '@values/application-purchase';

import { useApplicationModal } from './hooks/useApplicationModal';
import { ApplicationOnlineHelpModalBody } from './bodies/ApplicationOnlineHelpModalBody';

interface ApplicationOnlineHelpModalProps {
  isVisible: boolean;
  application: Application;
  category: HowToHelpType;
  onSuccess: () => void;
  onClose: () => void;
}

function useComponentState({ type }: { type: string | null }) {
  const defaultIcon = useGetIconOptimized('circle-man-with-laptop');
  const gradientIcon = useGetIconOptimized('circle-man-with-laptop-gradient');
  const icon = type === ApplicationModalPurchaseType.UnusedBoughtCertificates ? gradientIcon : defaultIcon;

  return { icon };
}

export const ApplicationOnlineHelpModal: React.FC<ApplicationOnlineHelpModalProps> = ({
  application,
  category,
  isVisible,
  onSuccess,
  onClose,
}) => {
  const {
    actions,

    amounts,
    selectedAmount,

    type,
    types,

    isLoading,
    isPaymentDisabled,

    shop,
    errors,
  } = useApplicationModal(application, category, { onSuccess });
  const { icon } = useComponentState({ type });

  return (
    <ModalBasic
      isVisible={isVisible}
      title="choose-amount"
      secondaryBtnLabel="cancel"
      approveBtnLabel="pay"
      imageHeading={{ optimized: icon }}
      onClose={onClose}
      onApprove={actions.onApproveHandler}
      isLoading={isLoading}
      isApproveBtnDisabled={isPaymentDisabled}
    >
      <ApplicationOnlineHelpModalBody
        application={application}
        amount={selectedAmount}
        amounts={amounts}
        shop={shop}
        type={type}
        types={types}
        onTypeChange={actions.setType}
        onAmountChange={actions.setSelectedAmount}
        onIsApprovedChange={actions.setIsOfferAgreementApproved}
        errors={errors}
      />
    </ModalBasic>
  );
};
